import './branche-full.scss';
import brancheFull from './branche-full.js';

export default brancheFull;
